<template>

        <b-dropdown-form style="width: 20rem;">
            <b-input-group @submit.stop.prevent>
                <b-form-select ref="reason" v-model="reason" :options="reasons">
                    <template #first>
                        <b-form-select-option disabled :value="null">Reason</b-form-select-option>
                    </template>
                </b-form-select>

                <b-input-group-append>
                    <b-button :disabled="!reason" v-if="!removing" variant="success" size="sm" @click="remove">Remove</b-button>
                    <b-button sm v-else variant="success" @click="remove" :disabled="true"><b-spinner small variant='light' class="mr-1"></b-spinner>Removing...</b-button>
                </b-input-group-append>
            </b-input-group>
            <b-input-group class="mt-2">
                <b-form-checkbox v-model="returnToStock" name="check-button" switch>
                    <span v-if="!returnToStock">Don't</span><span> Return To Stock</span>
            </b-form-checkbox>
            </b-input-group>
        </b-dropdown-form>

</template>

<script>
    import ordersApi from "../../api/orders";
    import removeItemOptions from "../../assets/removeItemOptions";
    import inventoryApi from "../../api/inventory";

    export default {
        name: "RemoveItem",
        mixins: [ removeItemOptions, ordersApi, inventoryApi ],

        props: ['orderId', 'item'],
        mounted() {
            this.$nextTick(() => {
                this.$refs.reason.$el.focus();
            });
        },
        data() {
            return {
                reason: null,
                returnToStock: false,
                removing: false,
            }
        },
        methods: {
            async remove() {
                this.removing = true;
                let reason = this.reason || null;
                let returnToStock = this.returnToStock || null;
                const updatedItems = await this.removeOrderItem(this.orderId, this.item.details.itemId, this.item.details.listing._id, this.item.details.quantity, reason, returnToStock);
                console.log('items', updatedItems);
                const updatedItem = updatedItems.find(item => item.details.listing._id === this.item.details.listing._id);
                console.log('item', updatedItem);
                if (returnToStock) {
                    const consigner = this.item.details.listing.consigner || null;
                    const source = this.item.details.listing.source || null;
                    const currentCount = await this.getQuantityByListingIds(this.item.details.listing._id);
                    const updatedCount = currentCount[0].count + this.item.details.quantity;
                    await this.restockListing(this.item.details.listing._id, updatedCount, consigner, source);
                }
                this.removing = false;
                this.reason = null;
                this.returnToStock = false;
                this.$emit('removeItem', updatedItem);
            }
        }
    }
</script>

<style scoped>

</style>